import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { ConsentBanner } from '../ConsentBanner';
import { Concierge } from '../Concierge';
import { Seo } from '../Seo';
import { track } from '../../lib/analytics';
import { routeSeo } from '../../data/seoRoutes';
export function SiteLayout() {
  const location = useLocation();
  React.useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'auto'
    });
    track('page_view', {
      path: location.pathname,
      referrer: document.referrer
    });
  }, [location.pathname]);

  // Static routes take their metadata from one map. Routes that depend on the
  // record being shown, articles, resources, service lines and Cavalla Gov,
  // render their own Seo on the page instead, so there is never a moment where
  // two sources compete for the same tags.
  const seo = routeSeo(location.pathname);
  return <div className="flex min-h-screen w-full flex-col bg-charcoal" data-id="element-224" data-mp="2z7sn6rwzwxg0">
      {seo && <Seo title={seo.title} description={seo.description} path={location.pathname} jsonLd={seo.jsonLd} noIndex={seo.noIndex} data-id="element-225" data-mp="1adn3iuzpv5n5" />}
      <Header data-id="element-226" data-mp="1k2eqeopx6zr7" />
      <main id="main" className="flex-1" data-id="element-227" data-mp="1k3py2zmhkrnl">
        <Outlet data-id="element-228" data-mp="1k50ycpgq3h9y" />
      </main>
      <Footer data-id="element-229" data-mp="1o4rul8p0qplv" />
      <Concierge data-id="element-230" data-mp="1o370tlaj3ap2" />
      <ConsentBanner data-id="element-231" data-mp="1o3qjx5bx054o" />
    </div>;
}